import { prepareBrands } from "src/services/brandRanking";

export function startRequest(state, sequence) {
  state.sequence = sequence;
  state.loading = true;
}

export function applyFacet(state, facet) {
  state.options = prepareBrands(facet?.options || []);
  state.selected = Object.freeze([...(facet?.selected || [])]);
  state.loading = false;
  state.loadedOnce = true;
  state.error = false;
}

/**
 * A failed fetch leaves `options` and `selected` exactly where they are.
 *
 * After a load has already succeeded that is the whole degraded state (#30):
 * the previous list stays usable for selection while its counts are withheld.
 * Nothing is set here to say so — `brandFacet/countsWithheld` derives it from
 * `error` and `loadedOnce`, so the two can never disagree.
 */
export function failFacet(state) {
  state.loading = false;
  state.error = true;
}

/**
 * Ask whoever owns the request to run it again. See `state.retryToken` for why
 * the signal goes through the store rather than an emit.
 */
export function requestRetry(state) {
  state.retryToken += 1;
}

/**
 * Clear the facet and retire whatever is already on the wire.
 *
 * `sequence` moves forward rather than standing still: a reset must not leave
 * an in-flight response looking current, or a fetch dispatched before an
 * unmount would land afterwards and repopulate the list the reset just
 * cleared, counts and all, for a filter context nobody is looking at.
 * Incrementing keeps it monotonic, so it can never collide with a live request
 * either. `retryToken` is deliberately left alone — moving it would walk the
 * retry signal backwards into a refetch nobody asked for.
 */
export function reset(state) {
  state.options = [];
  state.selected = [];
  state.loading = false;
  state.loadedOnce = false;
  state.error = false;
  state.sequence += 1;
}
